import * as THREE from 'three';

export const CONFIG = {
  camera: { width: 640, height: 480, facingMode: 'user' },
  blink: { earThreshold: 0.18, debounceMs: 80 },
  tongue: {
    jawOpenThreshold: 0.4,
    tongueOutThreshold: 0.3,
    debounceMs: 200,
    cooldownMs: 4000,
  },
  hand: {
    holdMs: 120,
    cooldownMs: 400,
    fingerExtensionMargin: 0.04,
  },
  run: {
    totalDinosaurs: Number.POSITIVE_INFINITY,
    winDefeatCount: 150,
    timeLimitMs: 180000,
    startBpm: 60,
    endBpm: 200,
    maxSpawnPerBeat: 4,
    difficultyRampMs: 180000,
    armoredSpawnRate: 0.12,
    armoredMinDifficulty: 0.15,
    maxConsecutiveArmored: 1,
  },
  shield: { durationMs: 3000, cleansePercent: 5 },
  shockwave: {
    wind: { durationMs: 400, maxRadius: 8, color: 0xfca, knockback: 0 },
    impact: { durationMs: 500, maxRadius: 15, color: 0xfb6, knockback: 5 },
    shield: { durationMs: 3000, maxRadius: 6, color: 0xffd, knockback: 3 },
  },
  dinosaur: {
    spawnIntervalMs: [3500, 6000] as [number, number],
    maxOnScreen: 7,
    compyGroupIntervalMs: [30000, 45000] as [number, number],
    trexFirstAppearMs: 30000,
    trexIntervalMs: [60000, 90000] as [number, number],
    reachOrbDistance: 1.8,
    stunDurationMs: 1500,
    spawnRadius: 18,
    spawnArcDeg: 360,
    spawnArcCenterDeg: 0,
    dangerRadius: 16,
  },
  weapons: {
    autoMeleeRange: 1.5,
    autoMeleeIntervalMs: 500,
    autoMeleeKnockback: 1,
  },
  corruption: {
    max: 100,
    respawnDurationMs: 3000,
    warnThreshold: 85,
    critThreshold: 95,
  },
  orb: { position: [0, 1.2, 0] as [number, number, number], baseRadius: 0.7 },
  scene: {
    fogColor: 0x1a2a1a,
    fogNear: 20,
    fogFar: 80,
    groundSize: 100,
  },
  colors: {
    orbCalmCenter: new THREE.Color('#fff8e8'),
    orbCalmMid: new THREE.Color('#ffd0a0'),
    orbCalmOuter: new THREE.Color('#fca'),
    orbCorruptCenter: new THREE.Color('#ff8866'),
    orbCorruptMid: new THREE.Color('#ff4422'),
    orbCorruptOuter: new THREE.Color('#aa3010'),
    windPulse: new THREE.Color('#fca'),
    impactPulse: new THREE.Color('#fb6'),
    shieldPulse: new THREE.Color('#ffd'),
    leafHealthy: new THREE.Color('#3d5a30'),
    leafWilted: new THREE.Color('#7a5530'),
    dirtGround: new THREE.Color('#2a1a0a'),
  },
};
